
import $ from 'jquery';

import template from './news-social.vhtml';
import { i18n } from '../../translation.js';

export default {
	template,
	props: {
		perPage: {
			type: Number,
			default: -1,
		},
		productLineColor: {
			type: String,
			default: '#89c0bd',
		},
		instagramColor: {
			type: String,
			default: '',
		},
		newsColor: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			page: 1,
			list: [],
			isLoading: false,
			isFetching: false,
			feedLoaded: false,
			newsLoaded: false,
			listSorted: false,
			loadMore: false,
		};
	},
	watch: {
		list() {
			if (this.feedLoaded && this.newsLoaded && !this.listSorted ) {
				this.listSorted = true;
			}
		},
		feed() {
			const setupFeed = this.feed.map( item => {
				item.img = item.images.standard_resolution.url;
				item.type = 'instagram';
				item.formated_time = this.formatDate( item.created_time );
				return item;
			});
			this.list = this.list.concat( setupFeed );
			this.feedLoaded = true;
		},
	},
	methods: {
		fetchMore: function () {
			this.page++;
			this.isFetching = true;
			getNews( this.perPage, this.page )
				.then(items => {
					if (items) {
						this.loadMore = this.perPage * this.page < items.total;
						this.setupList( items.news );
					}
				})
				.always(() => this.isFetching = false);
		},
		reload() {
			this.isLoading = true;
			getFeed()
				.then(response => {
					if (response) {
						let items = JSON.parse(response);
						const setupFeed = items.feed.map(item => {
							item.img = item.imageUrl;
							item.type = 'instagram';
							item.link = item.permalink;
							item.formated_time = this.formatStringDate(item.postedAt);
							return item;
						});
						this.list = this.list.concat(setupFeed);
						this.feedLoaded = true;
					}
				});
			getNews( this.perPage, this.page )
				.then(items => {
					if (items) {
						this.loadMore = this.perPage * this.page < items.total;
						this.setupList( items.news );
						this.newsLoaded = true;
					}
				})
				.always(() => this.isLoading = false);
		},
		setupList( array ) {
			const setupArray = array.map(item => {
				item.formated_time = this.formatDate(item.created_time);
				return item;
			});
			this.list = this.list.concat(setupArray);
			this.list.sort((a, b) => new Date( b.created_time * 1000 ) - new Date( a.created_time * 1000 ) );
		},
		formatStringDate(string){
			const formatedDate = new Date( string );
			return this.addZ( formatedDate.getDate() ) + '.' + this.addZ( formatedDate.getMonth() + 1 ) + '.' + formatedDate.getFullYear();
		},
		formatDate( timestamp ) {
			const formatedDate = new Date( timestamp * 1000 );
			return this.addZ( formatedDate.getDate() ) + '.' + this.addZ( formatedDate.getMonth() + 1 ) + '.' + formatedDate.getFullYear();
		},
		addZ( n ) { return n < 10 ? '0' + n : '' + n; },
	},
	created() {
		this.reload();
	},
};

/**
 * Gets resumes from WP REST API
 *
 * @param {string} post_type
 * @param {string} [search=""]
 * @returns {JQueryPromise<any>}
 */
function getFeed() {
	const params = {
		'limit': 20,
	};

	return $.get(`https://api.socialfeeds.qnty.dk/feed/kristensen/instagram`, params);
}
function getNews( perPage, page ) {
	const params = {
		'posts_per_page': perPage,
		'page': page,
		'lang': window.siteData.language,
	};
	return $.get(`/wp-json/kristensen/v1/news`, params);
}



// WEBPACK FOOTER //
// ./assets/_js/components/news-social/news-social.js